"use strict";

jQuery(document).ready(function ($) {
  var docWidth = window.innerWidth - document.documentElement.clientWidth;
  document.documentElement.style.setProperty('--scrollbar-width', docWidth > 0 ? docWidth + (docWidth / 2 + 1) + "px" : "18px");

  // Hamburger menu
  $('.hamburger').on('click', function () {
    $(this).toggleClass('is-active');
    $('.main-menu').slideToggle('slow');
  });

  // Hero block carousel
  $('.hero__image-carousel').slick({
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    speed: 400,
    pauseOnHover: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true
  });

  // Latest news carousel
  $('.news-strip__ticker').slick({
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    prevArrow: '<span class="news-strip__arrow news-strip__arrow--prev"></span>',
    nextArrow: '<span class="news-strip__arrow news-strip__arrow--next"></span>',
    speed: 400,
    pauseOnHover: true,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  // Product image carousel
  // $('.product-introduction__images--image-container').slick({
  // 	autoplay: false,
  // 	arrows: true,
  // 	prevArrow: $('.product-introduction__arrows--prev'),
  // 	nextArrow: $('.product-introduction__arrows--next'),
  // 	speed: 400,
  // 	pauseOnHover: true,
  // 	slidesToShow: 1,
  // 	slidesToScroll: 1
  // });

  // fix autoplay after dot clicked
  $('.slick-dots li button').focus(function () {
    this.blur();
  });

  // Select all links with hashes
  $('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]').not('[href="#0"]').click(function (event) {
    // On-page links
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, function () {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) {
            // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          }
        });
      }
    }
  });
  var scrollableElements = document.getElementsByClassName("side-scroll");
  var _loop = function _loop(i) {
    // scrollableElements[i].addEventListener('wheel', (event) => {
    // 	let scrollPosition = scrollableElements[i].scrollLeft;
    // 	let offsetWidth = scrollableElements[i].offsetWidth;
    // 	let scrollWidth = scrollableElements[i].scrollWidth;
    //
    // 	if (event.deltaY < 0 && scrollPosition > 0) {
    // 		event.preventDefault();
    // 		scrollableElements[i].scrollBy({
    // 			left: -30,
    // 		});
    // 	} else if (event.deltaY > 0 && scrollPosition < (scrollWidth - offsetWidth)) {
    // 		event.preventDefault();
    // 		scrollableElements[i].scrollBy({
    // 			left: 30,
    // 		});
    // 	}
    // });

    scrollableElements[i].style.cursor = 'grab';
    var pos = {
      top: 0,
      left: 0.1,
      x: 0,
      y: 0
    };
    var mouseDownHandler = function mouseDownHandler(e) {
      scrollableElements[i].style.cursor = 'grabbing';
      scrollableElements[i].style.userSelect = 'none';
      pos = {
        left: scrollableElements[i].scrollLeft,
        top: scrollableElements[i].scrollTop,
        // Get the current mouse position
        x: e.clientX,
        y: e.clientY
      };
      document.addEventListener('mousemove', mouseMoveHandler);
      document.addEventListener('mouseup', mouseUpHandler);
    };
    var mouseMoveHandler = function mouseMoveHandler(e) {
      // How far the mouse has been moved
      var dx = e.clientX - pos.x;
      var dy = e.clientY - pos.y;

      // Scroll the element
      scrollableElements[i].scrollTop = pos.top - dy;
      scrollableElements[i].scrollLeft = pos.left - dx;
    };
    var mouseUpHandler = function mouseUpHandler() {
      scrollableElements[i].style.cursor = 'grab';
      scrollableElements[i].style.removeProperty('user-select');
      document.removeEventListener('mousemove', mouseMoveHandler);
      document.removeEventListener('mouseup', mouseUpHandler);
    };

    // Attach the handler
    scrollableElements[i].addEventListener('mousedown', mouseDownHandler);
  };
  for (var i = 0; i < scrollableElements.length; i++) {
    _loop(i);
  }

  // Mobile hamburger menu
  $('.header__hamburger').on('click', function () {
    $(this).toggleClass('is-active');
    $('.header__nav--mobile').toggleClass('is-active');
    $('body').toggleClass('body-overflow');
  });
  $('.partner-logo-blocks__show-more').on('click', function () {
    $(this).toggleClass('is-active');
  });
  $('.user-timezone').val(Intl.DateTimeFormat().resolvedOptions().timeZone);
});